<template>
  <div class="body_monban" >
    <el-tabs  style="height: 200px;" v-model="activeName">
    <el-tab-pane label="退款管理" name="tuikuan"><tuikuan :admin_flag="0"></tuikuan></el-tab-pane>
     
  </el-tabs>

  </div>
</template>
<style>
.body_moban{
  padding-top: 100px;
}
</style>
<script>
import tuikuan from '../../tongyong/tuikuan.vue';
 
export default {
  components: {
    tuikuan: tuikuan 
 
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'tuikuan'
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
